const {
	REACT_APP_BASE_URL,
	NODE_ENV,
	REACT_APP_INSTRUMENTATION_KEY,
	REACT_APP_SENTRY_DSN,
	REACT_APP_GTAG,
	REACT_APP_FE_PROD,
	REACT_APP_FE_STAGING,
	REACT_APP_FE_DEV,
	REACT_APP_AG_GRID_KEY
} = process.env

export const ENV = {
	BASE_URL: REACT_APP_BASE_URL,
	NODE_ENV,
	INSTRUMENTATION_KEY: REACT_APP_INSTRUMENTATION_KEY,
	SENTRY_DSN: REACT_APP_SENTRY_DSN,
	GTAG: REACT_APP_GTAG,
	PROD: REACT_APP_FE_PROD,
	STAGGING: REACT_APP_FE_STAGING,
	DEV: REACT_APP_FE_DEV,
	AG_GRID_KEY: REACT_APP_AG_GRID_KEY
}

const missingKeys = [
	'BASE_URL',
	'NODE_ENV',
	'INSTRUMENTATION_KEY',
	'SENTRY_DSN',
	'GTAG'
].filter((key) => !ENV[key])

if (missingKeys.length) {
	ENV.MISSING_CONFIG = missingKeys.join(', ')
}

export const environments = {
	dev: 'develop',
	prod: 'prod',
	staging: 'staging',
	local: 'local'
}

export const getEnvironment = () => {
	let env = environments.local

	switch (window.location.origin) {
		case ENV.PROD:
			env = environments.prod
			break
		case ENV.STAGGING:
			env = environments.staging
			break
		case ENV.DEV:
			env = environments.dev
			break
		default:
			break
	}

	return env
}
